import example1 from "../../assets/videos/video1.mp4";
import example2 from "../../assets/videos/video2.mp4";
import example3 from "../../assets/videos/video3.mp4";
import example4 from "../../assets/videos/video4.mp4";
import example5 from "../../assets/videos/video5.mp4";
import example6 from "../../assets/videos/video6.mp4";

import preview1 from "../../assets/imgs/preview/preview1.png";
import preview2 from "../../assets/imgs/preview/preview2.png";
import preview3 from "../../assets/imgs/preview/preview3.png";
import preview4 from "../../assets/imgs/preview/preview4.png";
import preview5 from "../../assets/imgs/preview/preview5.png";
import preview6 from "../../assets/imgs/preview/preview6.png";

export const data = [
  {
    preview: preview1,
    video: example1,
  },
  {
    preview: preview2,
    video: example2,
  },
  {
    preview: preview3,
    video: example3,
  },
  {
    preview: preview4,
    video: example4,
  },
  {
    preview: preview5,
    video: example5,
  },
  {
    preview: preview6,
    video: example6,
  },
];
